/**
 * Funzioni di formattazione e calcolo condivise tra i componenti.
 */

/** Calcola giorni tra due date. Accetta Date objects. */
export function daysBetween(d1: Date | null, d2: Date | null): number | null {
  if (!d1 || !d2) return null;
  const ms = d2.getTime() - d1.getTime();
  return Math.round(ms / (1000 * 60 * 60 * 24));
}

interface FirestoreTimestamp {
  toDate: () => Date;
}

type DateFieldValue = string | Date | FirestoreTimestamp | null | undefined;

/** Converte un campo data (Firestore Timestamp o ISO string) in un Date object. */
export function parseDateField(val: DateFieldValue): Date | null {
  if (!val) return null;
  if (typeof val === 'object' && 'toDate' in val && typeof val.toDate === 'function') {
    return val.toDate();
  }
  if (val instanceof Date) return isNaN(val.getTime()) ? null : val;
  const d = new Date(val as string);
  return isNaN(d.getTime()) ? null : d;
}

/** Formatta una data in DD/MM/YYYY. Accetta Firestore Timestamp, ISO string, o Date. */
export function formatDate(val: DateFieldValue): string {
  if (!val) return '–';
  const d = parseDateField(val);
  if (!d) return '–';
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
}

/** Formatta una data in YYYY-MM-DD (per input type="date"). */
export function toDateStr(val: DateFieldValue): string {
  if (!val) return '';
  const d = parseDateField(val);
  if (!d) return '';
  return d.toISOString().slice(0, 10);
}

/** Formatta un importo in euro (es. "1.234 €"). Ritorna '–' se null. */
export function fmtEur(val: number | null | undefined): string {
  if (val == null) return '–';
  return val.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
}
